export default {
  container: 'grid justify-items-center',
  svg: 'self-center animate-spin h-8 w-8 border-4 rounded-3xl border-color-white border-dashed',
};
